import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PdToNpdFlowStore } from './pd-to-npd-flow.store';
import { provideComponentStore } from '@ngrx/component-store';

@Component({
  selector: 'app-pd-seller-flow',
  templateUrl: './pd-to-npd-flow.component.html',
  styleUrls: ['./pd-to-npd-flow.component.scss'],
  providers: [provideComponentStore(PdToNpdFlowStore)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdToNpdFlowComponent {
  constructor(public readonly cs: PdToNpdFlowStore) {}
}
